import { type ChipProps } from "ui/chip/chip";

/** `TextFieldWithCounter`'s counter: red past the limit, green with anything typed, neutral when empty. */
export const getCounter = (
  value: string | undefined,
  maxLength: number,
): { color: ChipProps["color"]; label: string } => {
  const length = value?.length ?? 0;
  const color = length > maxLength ? "error" : length > 0 ? "success" : "default";

  return { color, label: `${length}/${maxLength}` };
};
